import { api } from '../../apiClient';

// Order API service functions
export const orderService = {
  // Get all orders
  getAllOrders: async () => {
    const response = await api.get('/orders');
    return response.data;
  },

  // Get order by ID
  getOrderById: async (orderId) => {
    const response = await api.get(`/orders/${orderId}`);
    return response.data;
  },

  // Get orders by user
  getOrdersByUser: async (userId) => {
    const response = await api.get(`/orders/user/${userId}`);
    return response.data;
  },

  // Get orders by shop (for vendors)
  getOrdersByShop: async (shopId) => {
    const response = await api.get(`/orders/shop/${shopId}`);
    return response.data;
  },

  /** All orders across every shop owned by this user (requires auth). */
  getOrdersByOwner: async (ownerId) => {
    const response = await api.get(`/orders/owner/${ownerId}`);
    return response.data;
  },

  // Create order
  createOrder: async (orderData) => {
    const response = await api.post('/orders', orderData);
    return response.data;
  },

  // Create order from cart
  createOrderFromCart: async (orderData) => {
    const response = await api.post('/orders/cart', orderData);
    return response.data;
  },

  // Update order
  updateOrder: async (orderId, orderData) => {
    const response = await api.put(`/orders/${orderId}`, orderData);
    return response.data;
  },

  // Cancel order
  cancelOrder: async (orderId, updatedBy = 'user') => {
    const response = await api.patch(`/orders/${orderId}/cancel`, { updatedBy });
    return response.data;
  },

  // Refund order
  refundOrder: async (orderId) => {
    const response = await api.patch(`/orders/${orderId}/refund`);
    return response.data;
  },

  // Update order status (backend expects `orderStatus`, not `status`)
  updateOrderStatus: async (orderId, status) => {
    const response = await api.patch(`/orders/${orderId}/status`, {
      orderStatus: status,
      updatedBy: 'vendor',
    });
    return response.data;
  },
};

export default orderService;
